import React, { useEffect, useState } from "react";
import "./home.css"
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [currentLevel, setCurrentLevel] = useState(0);
  const levels = ["level1.png", "level2.png", "level3.png"];
  const navigate = useNavigate()

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentLevel((prevLevel) => (prevLevel + 1) % levels.length);
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div name="home" className="py-8 md:py-20 relative xl:min-h-screen  w-full">
      <div className="flex flex-row items-center gap-20 justify-center h-full  md:flex-col">
        <div className="flex flex-col relative justify-center items-center max-w-[90%] xl:max-w-[70%] text-center h-full sm:mt-20 md:mt-0 basis-[70%]">
          <img
            src={`../Assets/BannerLevelProp/level1.png`}
            alt={`Level`}
            className="zoom object-cover absolute w-[100px] -top-8 left-[40%]"
          />
          <img
            src={`../Assets/BannerLevelProp/level2.png`}
            alt={`Level`}
            className="zoom object-cover absolute w-[200px] -bottom-[10%] -left-[10%]"
          />
          <img
            src={`../Assets/BannerLevelProp/level3.png`}
            alt={`Level`}
            className="zoom object-cover absolute w-[150px] top-[35%] -right-[10%]"
          />
          <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-7xl font-pop font-semibold  text-black my-4 animate__animated  animate__fadeInDownBig animate__delay-1s">The future of Online Transactions.</h2>
          <p className="text-black font-pop lg:text-lg lg:max-w-[75%] my-4 animate__animated  animate__backInLeft animate__delay-1s">Paycott is the ultimate platform for secure transactions. Our innovative solution enables buyers and sellers to engage in online commerce with peace of mind.</p>
          <div>
            <button 
              className=" my-2 lg:my-4 font-pop text-xl bg-primarygreen hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-primarygreen py-2 px-4 border border-black-500 hover:border-primarygreen rounded-full w-80 text-white animate__animated animate__backInUp animate__delay-1s ease-in-out duration-300"
              onClick={()=>{
                navigate('/signup')
              }}
            >
              Get Started
            </button>
          </div>
        </div>

        <div className="animate__animated w-full HomeBG animate__backInRight  animate__delay-1s">
          <img
            src={"../Assets/Banner/HomeBanner.png"}
            alt="myprofile"
            className="rounded-2xl mx-auto w-1/4"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
